const Lang_SET = "careheroes/Lang/Lang_SET";
const User_TAKING_ASSESSMENT = "careheroes/assessments/User_TAKING_ASSESSMENT";
const User_NOT_TAKING_ASSESSMENT =
  "careheroes/assessments/User_NOT_TAKING_ASSESSMENT";

export default { Lang_SET, User_TAKING_ASSESSMENT, User_NOT_TAKING_ASSESSMENT };
